import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Button, SuiInput, SuiNumber, SuiSelect, SuiCheckbox, SuiRate, SuiSlider, sui, SuiForm } from "@sudy/sui-react";
import optionsStore, { getCityName } from './stores/optionsStore';
import { observable } from 'mobx';
import { observer } from "mobx-react";
import postStore from './stores/postStore';
// import UserCenter from "./page/usercenter"
import MainLayout from './page/base'
const { $inout } = sui;
/**
** mobx store
 */
const pageStore = observable({
  get cityName(){
    let city = getCityName(postStore.user.city, optionsStore.cities);
    return city ? city + "人" : "";
  },
  clickCount: 0
});

@observer
class App extends React.Component {

  render(){
    return (
        <div>
            {/* <UserCenter></UserCenter> */}
            <MainLayout></MainLayout>
        </div>
    )
  }
}

export default App;